import Api from 'api/api';
import { queryKeys } from 'api/queryKeys';

export const registries = {
  queryKey: queryKeys.registries,
  queryFn: Api.getRegistries,
};
